import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  usePromptsByCategoryInfinite,
  useSystemPromptCategories,
} from '@/modules/system-prompts/api';

import { EventSystemPromptResponse } from '../../../../../types';

export function useSystemPromptSection(
  eventSystemPrompt: EventSystemPromptResponse | null
) {
  const { watch, setValue } = useFormContext();

  const selectedCategoryId = watch('systemPromptCategoryId') ?? '';
  const systemPromptId = watch('systemPromptId') ?? '';

  const { data: categories } = useSystemPromptCategories();

  const {
    data: prompts,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = usePromptsByCategoryInfinite(selectedCategoryId);

  // Pre-select the category that matches the saved prompt's category name
  useEffect(() => {
    if (selectedCategoryId || !eventSystemPrompt?.systemPromptCategory || categories.length === 0) {
      return;
    }
    const match = categories.find(
      (c) => c.name === eventSystemPrompt.systemPromptCategory
    );
    if (match) setValue('systemPromptCategoryId', match.id);
  }, [categories, eventSystemPrompt?.systemPromptCategory, selectedCategoryId, setValue]);

  const showContentFields =
    !!eventSystemPrompt || (!!selectedCategoryId && !!systemPromptId);

  const categoryOptions = categories.map((c) => ({ id: c.id, value: c.name }));
  const promptOptions = prompts.map((p) => ({ id: p.id, value: `v${p.version}` }));

  const onCategoryChange = () => {
    setValue('systemPromptId', '', { shouldDirty: true });
  };

  return {
    selectedCategoryId,
    onCategoryChange,
    categoryOptions,
    promptOptions,
    showContentFields,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  };
}
